import { InvoiceList } from "Components/InvoiceList";

const InvoicePage = () => <InvoiceList />;

export default InvoicePage;
